import env from '@byted/ecom-mobile-lib/lib/core/env';

const ua = navigator.userAgent;
// lib 里的抖音appVersion是匹配的ua中 aweme_100300 版本号，这块在10以后被补0了，没法直接用semver来计算
// 所以改为去取ua中的app_version后面的版本号，这里的版本号格式是 x.x.x，不会补0
if (env.isInAweme && env.isAndroid) {
    const versionMatch = ua.match(/app_version\/([\d.]+)/);
    const version = versionMatch ? versionMatch.pop() : env.appVersion;
    env.appVersion = version ? version : '0.0.0';
}
export default env;
